export default "__VITE_ASSET__CTU4SM00__"